module.exports = __webpack_public_path__ + "static/img_2459_optimized-bb757b95c95844641ecf0a4c39b6719d.jpg";